import { Component, ViewChildren, Output, EventEmitter, Input, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from "ngx-spinner";
import { scan, take, timer } from 'rxjs';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss'],
})

export class OtpComponent implements OnInit {

  formInput = ['input1', 'input2', 'input3', 'input4', 'input5'];
  @ViewChildren('formRow') rows: any;
  @Input() callbackFunction: any;
  @Input('purpose') purpose: string | any;
  @Output() confirmationEvent = new EventEmitter<any>();
  @Output() verificationEvent = new EventEmitter<any>();
  @Output() resendEvent = new EventEmitter<any>();

  form: FormGroup<any>;
  otp: any;
  storedData: any;
  specificCancelData: any;
  messageEvent: any;
  entireCancelData: any;
  // loading: boolean = false;
  isLoading = false;
  showComponent: boolean = false;
  errorMessage: string = "";
  timeSubscriber: any;
  interval = 180;
  timeLeft = 0;
  remainingTime = 0;
  otpCounter = 0;

  constructor(private router: Router, private apiService: ApiService, private storage: StorageService, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, public dialogRef: MatDialogRef<OtpComponent>, private route: ActivatedRoute, private snackBar: MatSnackBar, private spinner: NgxSpinnerService) {
    this.form = this.toFormGroup(this.formInput);
  }

  toFormGroup(elements: any) {
    const group: any = {};
    elements.forEach((key: any) => {
      group[key] = new FormControl('', [Validators.required, Validators.pattern('^[0-9]{1}$')]);
    });
    return new FormGroup(group);
  }

  keyUpEvent(event: any, index: number) {
    const isNumber = isFinite(event.key);
    if (isNumber || (event.keyCode === 8) || (event.keyCode === 46)) {
      let pos = index;
      if ((event.keyCode === 8 && event.which === 8)) {
        pos = index - 1;
      } else {
        pos = index + 1;
      }
      if (pos > -1 && pos < this.formInput.length) {
        this.rows._results[pos].nativeElement.focus();
      } else if ((pos > -1 && pos == this.formInput.length) && ((event.keyCode !== 8) || (event.keyCode !== 46)) && (event.target.value !== "")) {
        this.rows._results[index].nativeElement.blur();
      }
    }
  }

  async editBooking(applicantData: any) {
    this.storage.set('prefill_data', JSON.stringify(applicantData));
    await this.apiService.getFormById(applicantData.form_id).then((data: any) => {
      if (data["success"]) {
        this.storage.set('form_data', JSON.stringify(data));
      }
    });
    await this.router.navigate(['/edit-form']);
  }

  getOtp() {
    this.otp = Object.keys(this.form.value).map((value) => { return this.form.value[value]; }).join('');
    this.confirmationEvent.emit(this.otp);

    let purpose = this.data.purpose;
    let type = this.data.type;
    let participant = this.data.participant;
    let bookingId = this.data.bookingId;
    let applicantData = this.data.applicantData;
    let formBookingDetails = this.data.formBookingDetails;

    // Data for passing to the verify otp Api Call
    this.storedData = {
      participant: participant,
      purpose: purpose,
      otp: this.otp,
    };

    // Data for passing to the cancel specific applicant Api Call
    this.specificCancelData = {
      applicant_id: participant,
      otp: this.otp,
    };
    // Data for passing to the cancel Entire Booking Api Call
    this.entireCancelData = {
      booking_id: bookingId,
      otp: this.otp,
    };

    // mat spinner 
    this.isLoading = true;
    this.errorMessage = "";

    if (this.storedData) {
      // Calling function for verifying otp
      this.apiService.verifyOtp(this.storedData).subscribe({
        next: (response: any) => {
          if (response["success"]) {
            // mat spinner 
            this.isLoading = false;
            this.errorMessage = "";
            // this.verificationEvent.emit(true);
            this.dialogRef.close();
            this.snackBar.open('Verification Successful', 'Close', {
              duration: 1000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: ['green-snackbar']
            });

            switch (type) {
              case 'entireCancel':
                // mat spinner 
                this.spinner.show();
                // Calling function for cancel Entire Booking
                this.apiService.cancelEntireAppointment(this.entireCancelData).subscribe({
                  next: (response: any) => {
                    if ((response["success"])) {
                      // mat spinner 
                      this.spinner.hide();
                      this.snackBar.open(response.message, 'Close', {
                        duration: 3000,
                        horizontalPosition: 'center',
                        verticalPosition: 'top',
                        panelClass: 'green-snackbar'
                      });
                      setTimeout(() => {
                        this.router.navigate(['/track-appointment']);
                      }, 3000);
                    } else {
                      this.spinner.hide();
                      this.snackBar.open(response.message, 'Close', {
                        duration: 0,
                        horizontalPosition: 'center',
                        verticalPosition: 'top',
                        panelClass: 'red-snackbar'
                      });
                    }
                  },
                  error: (err: any) => {
                    this.spinner.hide();
                    this.snackBar.open(err.error.message, 'Close', {
                      duration: 0,
                      horizontalPosition: 'center',
                      verticalPosition: 'top',
                      panelClass: 'red-snackbar'
                    });
                  },
                  complete: () => { }
                });
                break;

              case 'specificCancel':
                // mat spinner 
                this.spinner.show();
                // Calling function for cancel Specific Applicant
                this.apiService.cancelSpecificAppointment(this.specificCancelData).subscribe({
                  next: (response: any) => {
                    if ((response["success"])) {
                      this.spinner.hide();
                      this.snackBar.open(response.message, 'Close', {
                        duration: 1000,
                        horizontalPosition: 'center',
                        verticalPosition: 'bottom',
                        panelClass: 'green-snackbar'
                      });
                      setTimeout(() => {
                        this.router.navigate(['/track-appointment']);
                      }, 1000);
                    } else {
                      this.spinner.hide();
                      this.snackBar.open(response.message, 'Close', {
                        duration: 3000,
                        horizontalPosition: 'center',
                        verticalPosition: 'bottom',
                        panelClass: 'red-snackbar'
                      });
                    }
                  },
                  error: (err: any) => {
                    this.spinner.hide();
                    this.snackBar.open(err.error.message, 'Close', {
                      duration: 3000,
                      horizontalPosition: 'center',
                      verticalPosition: 'bottom',
                      panelClass: 'red-snackbar'
                    });
                  },
                  complete: () => { }
                });
                break;

              case 'entireReschedule':
                this.router.navigate(['/reschedule-appointment']);
                break;

              case 'specificReschedule':
                this.router.navigate(['/reschedule-appointment']);
                break;

              case 'edit':
                this.editBooking(applicantData);
                break;

              case 'form':
                this.goToForms(formBookingDetails.form_id);
                break;

              default:
                break;

            }

          } else {
            this.isLoading = false;
            this.snackBar.open("Verification Unsuccessful", 'Close', {
              duration: 0,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              panelClass: ['red-snackbar']
            });
          }
        },
        error: (err: any) => {
          this.isLoading = false;
          this.errorMessage = err.error.message;
          setTimeout(() => {
            this.errorMessage = "";
          }, 3000);
        },
        complete: () => { }
      });
    }
  }

  async goToForms(formId: any) {
    await this.apiService.getFormById(formId).then((data: any) => {
      if (data["success"]) {
        this.storage.set('form_data', JSON.stringify(data));
      }
    });
    await this.router.navigate(['/form']);
  }

  timer() {
    this.timeSubscriber =
      timer(0, 1000).pipe(
        scan((acc) => acc + 1, 0),
        take(180) // <- Stops after the given seconds
      );
    this.timeSubscriber.subscribe((value: number) => {
      this.timeLeft = this.interval - value;
      this.remainingTime = new Date(2023, 0, 1).setSeconds(this.timeLeft);
    });

  }

  resendOtp() {
    this.otpCounter++;
    this.resendEvent.emit(true);
    this.timer();
  }

  ngOnInit(): void {
    this.timer();
  }
  ngOnDestroy() {
    this.otpCounter = 0;
    this.dialogRef && this.dialogRef.close();
    this.timeSubscriber.unsubscribe();
  };

}
